module.exports = __webpack_public_path__ + "img/app.5686dcfa.png";